<template>
  <aside :class="['app-sidebar', { collapsed: sidebarCollapsed }]">
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      :collapse="sidebarCollapsed"
      :background-color="sidebarBg"
      :text-color="sidebarText"
      :active-text-color="sidebarActive"
      @select="handleMenuSelect"
    >
      <el-menu-item index="/dashboard">
        <i class="el-icon-s-home"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="/stats">
        <i class="el-icon-s-data"></i>
        <span slot="title">数据看板</span>
      </el-menu-item>
      <el-submenu index="robots">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>机器人管理</span>
        </template>
        <el-menu-item index="/robots">机器人列表</el-menu-item>
      </el-submenu>
      <el-submenu index="projects">
        <template slot="title">
          <i class="el-icon-folder"></i>
          <span>项目管理</span>
        </template>
        <el-menu-item index="/projects">项目列表</el-menu-item>
      </el-submenu>
      <el-submenu index="workflow">
        <template slot="title">
          <i class="el-icon-s-management"></i>
          <span>流程管理</span>
        </template>
        <el-menu-item index="/templates">步骤模板</el-menu-item>
      </el-submenu>
      <el-submenu index="tasks">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>任务管理</span>
        </template>
        <el-menu-item index="/tasks">任务列表</el-menu-item>
      </el-submenu>
      <el-submenu index="sessions">
        <template slot="title">
          <i class="el-icon-message"></i>
          <span>会话管理</span>
        </template>
        <el-menu-item index="/sessions">会话列表</el-menu-item>
      </el-submenu>
      <el-submenu index="worklog">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>工作日志</span>
        </template>
        <el-menu-item index="/work-logs">日志列表</el-menu-item>
        <el-menu-item index="/work-log-stream">实时动态</el-menu-item>
        <el-menu-item index="/summary-list">工作总结</el-menu-item>
      </el-submenu>
      <el-submenu index="system">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item index="/apikeys">API Key</el-menu-item>
      </el-submenu>
    </el-menu>
  </aside>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Sidebar',
  props: {
    // 当前激活的菜单
    activeMenu: {
      type: String,
      default: '/dashboard'
    }
  },
  computed: {
    ...mapState('app', ['sidebarCollapsed']),
    sidebarBg() {
      return getComputedStyle(document.documentElement).getPropertyValue('--sidebar-bg').trim() || '#ffffff'
    },
    sidebarText() {
      return getComputedStyle(document.documentElement).getPropertyValue('--sidebar-text').trim() || '#606266'
    },
    sidebarActive() {
      return getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || '#409EFF'
    }
  },
  methods: {
    handleMenuSelect(index) {
      this.$emit('select', index)
      // 避免重复导航到当前页面
      if (this.$route.path !== index) {
        this.$router.push(index).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-sidebar {
  width: 210px;
  background-color: var(--sidebar-bg, #ffffff);
  border-right: 1px solid var(--border-light, #e4e7ed);
  transition: width 0.3s;
  overflow-y: auto;
  flex-shrink: 0;

  &.collapsed {
    width: 64px;
  }
}

.sidebar-menu {
  border: none;
  background-color: transparent;

  ::v-deep .el-menu-item,
  ::v-deep .el-submenu__title {
    &:hover {
      background-color: var(--bg-page, #f5f7fa) !important;
    }
  }

  ::v-deep .el-menu-item.is-active {
    background-color: var(--primary-light, #ecf5ff) !important;
  }
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .app-sidebar {
    position: absolute;
    left: 0;
    top: 60px;
    height: calc(100% - 60px);
    z-index: 999;
  }
}
</style>
